/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpsertConfigRequestBody = {
  /**
   * Provider API key. Stored encrypted at rest; never returned on reads.
   */
  apiKey: string;
  /**
   * How the provider org is billed: 'metered', 'flat_rate', or 'unknown'. Free-form; omit to leave the existing value unchanged.
   */
  billingMode?: string | undefined;
  /**
   * Whether the integration should be active.
   */
  enabled: boolean;
  /**
   * Provider scope identifier. Required for anthropic_compliance and codex_compliance (organization id) and chatgpt_compliance (ChatGPT workspace UUID).
   */
  externalOrganizationId?: string | undefined;
  /**
   * AI provider identifier. Supported values include cursor, anthropic_compliance, codex_compliance, and chatgpt_compliance.
   */
  provider: string;
};

/** @internal */
export type UpsertConfigRequestBody$Outbound = {
  api_key: string;
  billing_mode?: string | undefined;
  enabled: boolean;
  external_organization_id?: string | undefined;
  provider: string;
};

/** @internal */
export const UpsertConfigRequestBody$outboundSchema: z.ZodMiniType<
  UpsertConfigRequestBody$Outbound,
  UpsertConfigRequestBody
> = z.pipe(
  z.object({
    apiKey: z.string(),
    billingMode: z.optional(z.string()),
    enabled: z.boolean(),
    externalOrganizationId: z.optional(z.string()),
    provider: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apiKey: "api_key",
      billingMode: "billing_mode",
      externalOrganizationId: "external_organization_id",
    });
  }),
);

export function upsertConfigRequestBodyToJSON(
  upsertConfigRequestBody: UpsertConfigRequestBody,
): string {
  return JSON.stringify(
    UpsertConfigRequestBody$outboundSchema.parse(upsertConfigRequestBody),
  );
}
